import { sharedTracker } from '../Tracker'
import events from '../events'

export const trackClickedPaywallChip = (
	{ planName, feature, origin }: { planName: string, feature: string, origin?: string }
) => sharedTracker
	.trackPaywallAction( {
		action: events.paywall.CLICKED_PAYWALL_CHIP,
		chip_plan_name: planName,
		feature,
		origin
	} );
